import { GLOBAL_CONSTANTS } from "../global/constants";
const urlRegex = require('url-regex');

export function validateURL(url) {
  if (!url || typeof url !== "string") return false;
  try {
    let result = urlRegex({ exact: true, strict: false }).test(url);
    if (!result) return false;
    // eslint-disable-next-line no-useless-escape
    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return !format.test(url[0]);
  } catch (error) {
    return false;
  }
}

export function validateFullURL(url) {
  try {
    new URL(url);
  } catch (error) {
    return false;
  }
  return validateURL(url);
}

export function validateEmail(mail) {
  // eslint-disable-next-line no-useless-escape
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail.trim())) {
    return true;
  }
  return false;
}

export function validatePassword(password, compare) {
  // return password && password.match(/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[0-9]){6,}$/);
  return password && password.length > 5 && (!compare || compare === password);
}


export function validatePhone(phone) {
  const regex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
  return typeof phone == "string" ? regex.test(phone) : phone.getNumber() && phone.isValidNumber();
}

export function validatePhoneEmpty(phone) {
  return !phone || !phone.getNumber() || (phone.getNumber() && phone.isValidNumber());
}

export function validateCode(code) {
  return code && code.length >= 6;
}

export function validateOrderValue(value) {
  return (value + "").replace(/,/g, "") * 1 >= 0;
}

export function validate({
  selector,
  validator = function (data) { return !!data; },
  ignore = false,
  showInvalid = true,
  customVal = undefined,
  compare,
  type = GLOBAL_CONSTANTS.INPUT_TYPE.INPUT,
  isFocus = true,
} = {}) {
  const element = window.$(selector);
  const classElement = type === GLOBAL_CONSTANTS.INPUT_TYPE.PHONE ? element.parent() : element;
  let value = element.val() && typeof element.val() === "string" ? element.val().trim() : element.val();
  if (!validator(customVal !== undefined ? customVal : value, compare) && !ignore) {
    if (showInvalid) {
      classElement.toggleClass("not-empty", !!value);
      classElement.addClass("is-invalid");
      if (isFocus) {
        if (type === GLOBAL_CONSTANTS.INPUT_TYPE.SELECT) {
          element[0].selectize.focus();
        } else {
          element.focus();
        }
      }
    }
    return false;
  } else {
    classElement.removeClass("not-empty is-invalid");
    return true;
  }
}